// extracted by mini-css-extract-plugin
export default {"box":"Entrar_box__6Z4Nx","logo_menu":"Entrar_logo_menu__iFPrl"};